export default __webpack_public_path__ + "static/media/home-green.7438f9c4.svg";